import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";

const BeforeMock = () => (
  <div className="flex h-full flex-col bg-[#D8D5CE] p-4 sm:p-6">
    <div className="flex items-center justify-between bg-[#B34A3A] px-3 py-2">
      <span className="text-[10px] font-bold uppercase tracking-wide text-white">Welcome To Our Website!!</span>
      <span className="text-[9px] text-white/80 underline">click here</span>
    </div>
    <div className="mt-3 grid grid-cols-3 gap-2">
      <div className="h-14 bg-[#7A7A72] sm:h-20" />
      <div className="h-14 bg-[#3F5E8C] sm:h-20" />
      <div className="h-14 bg-[#8C8C82] sm:h-20" />
    </div>
    <div className="mt-3 space-y-1.5">
      <div className="h-2 w-full bg-[#A5A29A]" />
      <div className="h-2 w-11/12 bg-[#A5A29A]" />
      <div className="h-2 w-4/5 bg-[#A5A29A]" />
    </div>
    <div className="mt-auto flex gap-2">
      <span className="bg-[#C9A227] px-3 py-1.5 text-[9px] font-bold uppercase text-black">Best prices</span>
      <span className="bg-[#3F5E8C] px-3 py-1.5 text-[9px] font-bold uppercase text-white">Call now</span>
    </div>
  </div>
);

const AfterMock = () => (
  <div className="flex h-full flex-col bg-[#0B0C0E] p-4 sm:p-6">
    <div className="flex items-center justify-between">
      <span className="font-display text-[10px] font-bold tracking-[0.35em] text-[#F4F4F6]">
        KRONOS<span className="text-[#2563EB]">.</span>
      </span>
      <span className="rounded-full bg-[#2563EB] px-3 py-1 text-[9px] font-medium text-white">Start a Project</span>
    </div>
    <p className="mt-6 max-w-[70%] font-display text-base font-semibold leading-snug text-[#F4F4F6] sm:mt-10 sm:text-2xl">
      We build websites people remember.
    </p>
    <div className="mt-3 space-y-1.5">
      <div className="h-1.5 w-3/5 bg-white/15" />
      <div className="h-1.5 w-2/5 bg-white/10" />
    </div>
    <div className="mt-auto grid grid-cols-3 gap-2">
      <div className="h-12 border border-white/10 bg-white/[0.03] sm:h-16" />
      <div className="h-12 border border-white/10 bg-white/[0.03] sm:h-16" />
      <div className="h-12 border border-[#2563EB]/30 bg-[#2563EB]/10 sm:h-16" />
    </div>
  </div>
);

export const BeforeAfter = () => {
  const [pos, setPos] = useState(50);

  return (
    <section data-testid="before-after-section" className="border-t border-white/5 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <SectionTag testId="before-after-tag">The Difference</SectionTag>
        <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <h2 className="max-w-xl font-display text-2xl font-semibold tracking-tight text-[#F4F4F6] sm:text-3xl lg:text-4xl">
              Outdated to undeniable.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-md text-sm leading-relaxed text-[#9498A4]">
              Drag the divider. Weak mobile experience, no clear CTA, inconsistent branding —
              replaced by a focused, responsive, conversion-oriented presence.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-14">
          <div className="relative aspect-[16/10] select-none overflow-hidden border border-white/10 sm:aspect-[16/8]">
            <div className="absolute inset-0">
              <BeforeMock />
            </div>
            <div className="absolute inset-0" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
              <AfterMock />
            </div>
            <div className="absolute inset-y-0 w-px bg-[#2563EB] shadow-[0_0_18px_rgba(37,99,235,0.9)]" style={{ left: `${pos}%` }} />
            <span className="absolute left-4 top-4 bg-[#0B0C0E]/70 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F4F6] backdrop-blur-sm">
              Before
            </span>
            <span className="absolute right-4 top-4 bg-[#2563EB] px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white">
              After
            </span>
            <input
              type="range"
              min="0"
              max="100"
              value={pos}
              onChange={(e) => setPos(Number(e.target.value))}
              aria-label="Compare before and after"
              data-testid="before-after-slider"
              className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
